import React, { Component } from 'react'
import "./Style.css"
export default class Success extends Component {
    
   
  
    render() {

    
    return (
      <div className="style mt-5 card animated bounceIn">
        <div className="card-body text-center pt-5 pb-5">
            <i className="fas fa-check-circle fa-7x text-success"></i>
            <h1>Hang Tight while your Resume Downloads!</h1>
            <br/>
            
        </div>  
        
      </div>
    )
  }
}
